import apiConfig from "../../services/apiConfig";
import { useState, useEffect, useContext } from "react";
import axios from 'axios';
import { AuthContext } from "./AuthContext";

const useAuth = () => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState('');
  const authContext = useContext(AuthContext);

  useEffect(() => {
    const storedUserData = localStorage.getItem('userData');
    if (storedUserData) {
      const userData = JSON.parse(storedUserData);
      const { tokenExpiration } = userData;
      const isTokenExpired = isExpired(tokenExpiration);

      if (!isTokenExpired) {
        setUser(userData);
      } else {
        // Si el token ha expirado, limpia los datos del usuario almacenados en localStorage
        localStorage.removeItem('userData');
      }
    }
  }, []);

  const login = async (email, password) => {
    try {
      setError(''); // Limpiar errores previos

      var body = {
        Email: email,
        Password: password
      }

      const response = await axios.post(`${apiConfig.baseUrl}/api/usuario/login`, body);

      const { fullName, roles, email: userEmail, token, tokenExpiration, tenants } = response.data;

      // Determinar nombre del tenant
      let tenantName = null;
      if (tenants && tenants.length > 0) {
        tenantName = tenants[0].nombre; // Si tiene un solo tenant, usar su nombre
      }

      const userData = { fullName, roles, email: userEmail, token, tokenExpiration, tenants, tenantName };
      setUser(userData);

      // Guarda los datos del usuario en localStorage para persistencia
      localStorage.setItem('userData', JSON.stringify(userData));
    } catch (error) {
      // Capturar mensaje específico del backend
      let errorMsg = 'Credenciales inválidas';
      
      if (error.response?.data) {
        const errorData = error.response.data;
        
        // Si el backend devuelve un objeto con mensaje
        if (errorData.message) {
          errorMsg = errorData.message;
        }
        // Si el backend devuelve un string directamente
        else if (typeof errorData === 'string') {
          errorMsg = errorData;
        }
        // Si es el error específico de no_tenants
        else if (errorData.error === 'no_tenants') {
          errorMsg = errorData.message || 'El usuario no tiene asignado ningún tenant. Contacte al administrador.';
        }
      }
      
      setError(errorMsg);
      throw error;
    }
  };

  const logout = () => {
    setUser(null);
    setError(null);
    // Limpia los datos del usuario almacenados en localStorage al cerrar sesión
    localStorage.removeItem('userData');
  };

  const isExpired = (expiration) => {
    const tokenExpiration = new Date(expiration);
    const currentDateTime = new Date();
    return tokenExpiration <= currentDateTime;
  };

  return { user, error, login, logout, ...authContext };
};

export default useAuth;










